<template>
	<div class="m-l-30 m-t-10 w-500" style="background-color:#fff;padding:20px;">
		<el-form ref="form" :model="form" :rules="rules" label-width="110px">
			<el-form-item label="标题" prop="title">
				<el-input v-model.trim="form.title" class="h-40 w-200"></el-input>
			</el-form-item>
			<el-form-item label="绑定权限规则" prop="rule_name">
				<el-input v-model.trim="form.rule_name" class="h-40 fl w-200" :disabled="true"></el-input>
        <el-button class="fl m-l-30" @click="openRule()">查找</el-button>
				<el-button class="fl m-l-10" @click="clearRule()">清空</el-button>
			</el-form-item>
			<el-form-item label="菜单类型" prop="menu_type">
				<el-radio-group v-model="form.menu_type">
					<el-radio disabled label="1">普通三级菜单</el-radio>
					<el-radio disabled label="2">单页菜单</el-radio>
					<el-radio disabled label="3">外链</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="上级菜单" prop="pid">
				<el-select disabled v-model="pMenu" placeholder="请选择活动区域" class="w-200">
					<el-option v-for="item in options" :label="item.title" :value="item"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="URI/URL">
        <el-input v-model.trim="form.url" class="h-40 w-200"></el-input>
      </el-form-item>
      <el-form-item label="一级菜单标识" prop="module">
        <el-input v-model.trim="form.module" class="h-40 w-200" :disabled="form.pid != 0"></el-input>
      </el-form-item>
      <el-form-item label="三级菜单标识" prop="menu">
        <el-input v-model.trim="form.menu" class="h-40 w-200" :disabled="form.menu_type != 1"></el-input>
      </el-form-item>
      <!-- <el-form-item label="子菜单来源">
        <el-input v-model.trim="form.from" class="h-40 w-200"></el-input>
      </el-form-item> -->
			<el-form-item label="排序">
				<el-input v-model="form.sort" class="h-40 w-200"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="edit()" :loading="isLoading">提交</el-button>
				<el-button @click="goback()">返回</el-button>
			</el-form-item>
		</el-form>
		<ruleList ref="ruleList"  @selectRule="selectRule" :title="title"></ruleList>
	</div>
</template>

<script>
  import ruleList from '../../../Common/business/rule.vue'
  import http from '../../../../assets/js/http'

  export default {
    data() {
      return {
        isLoading: false,
        id: null,
        title: '通知公告',
        form: {
          title: '',
          rule_name: '',
          rule_id: null,
          pid: '',
          menu_type: '1',
          url: '',
          module: '',
          menu: '',
          sort: '',
          from: ''
        },
        options: [{ id: 0, title: '无' }],
        rules: {
          title: [
            { required: true, message: '请输入菜单标题' }
          ],
          // rule_name: [
          //   { required: true, message: '请绑定权限标识' }
          // ],
          menu_type: [
            { required: true, message: '请选择菜单类型' }
          ],
          module: [
            { required: true, message: '请填写一级菜单标识' }
          ],
          menu: [
            { required: false, message: '请填写三级菜单标识' }
          ],
          pid: [
            { type: 'number', required: true, message: '请选择上级菜单' }
          ]
        },
        pMenu: {},
        firstTime: true
      }
    },
    methods: {
      edit() {
        this.$refs.form.validate((pass) => {
          if (pass) {
            this.isLoading = !this.isLoading
            this.apiPut('admin/menus/', this.id, this.form).then((res) => {
              if (res.code == 200) {
                _g.toastMsg(this, 'success', '编辑成功')
                _g.updateMenus()
                setTimeout(() => {
                  this.goback()
                }, 1500)
              } else {
                this.isLoading = !this.isLoading
                _g.dealError(this, res)
              }
            })
          }
        })
      },
      openRule() {
        this.$refs.ruleList.open()
      },
      clearRule() {
        this.form.rule_id = null
        this.form.rule_name = ''
      },
      goback() {
        router.go(-1)
      },
      getMenus() {
        this.apiGet('admin/menus').then((res) => {
          if (res.code == 200) {
            let array = []
            _(res.data).forEach((res) => {
              if (res.level != 3 && res.menu_type == 1) {
                array.push(res)
              }
            })
            this.options = this.options.concat(array)
          } else {
            _g.dealError(this, res)
          }
          this.getDetail()
        })
      },
      getDetail() {
        this.apiGet('admin/menus/' + this.id).then((res) => {
          if (res.code == 200) {
            res.data.menu_type = res.data.menu_type.toString()
            this.form = res.data
            _(this.options).forEach((item) => {
              if (this.form.pid === item.id) {
                this.pMenu = item
                return false
              }
            })
          } else {
            _g.dealError(this, res)
          }
        })
      },
      selectRule(id, title_else, title) {
        this.form.rule_name = title
        this.form.rule_id = id
      }
    },
    created() {
      this.getMenus()
      this.id = this.$route.params.id
    },
    watch: {
      'pMenu'() {
        if (this.firstTime) {
          this.firstTime = false
          return
        }
        this.form.pid = this.pMenu.id
        this.form.module = this.pMenu.module
      }
    },
    components: {
      ruleList
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// edit.vue?57c5899a